<div
    class="card-events"
    [ngClass]="{
        'card-events--grid-layout': block.data.layout === 'Grid',
        'card-events--carousel-layout': block.data.layout === 'Carousel',
    }"
    [style]="`
    --bg-color: ${block.data.bgColour};
    --event-card-text-color: ${block.data.eventTextColor};
    --event-card-border-radius: ${block.data.borderRadius};
    `">
    @if (block.data.layout === 'Carousel') {
        <swiper #swiperRef [config]="swiperConfig" (indexChange)="onSlideChange($event)">
            @for (item of block.content; track item.id) {
                <div swiperSlide>
                    <ng-container *ngTemplateOutlet="cardEvent; context: { item: item }"></ng-container>
                </div>
            }
        </swiper>

        @if (paginationPages.length > 1) {
            <div class="carousel-nav-wrapper">
                <button class="carousel-nav carousel-nav--prev" (click)="prev()" aria-label="Previous slide">
                    <core-icon [name]="'chevron-left-single'" [size]="15"></core-icon>
                </button>

                <div class="carousel-pagination">
                    @for (i of paginationPages; track i) {
                        <button
                            class="carousel-page-btn"
                            [class.is-active]="activeIndex === i"
                            (click)="goToSlide(i)"
                            [attr.aria-label]="'Go to slide ' + (i + 1)">
                            {{ i + 1 }}
                        </button>
                    }
                </div>

                <button class="carousel-nav carousel-nav--next" (click)="next()" aria-label="Next slide">
                    <core-icon [name]="'chevron-right-single'" [size]="15"></core-icon>
                </button>
            </div>
        }
    }

    @if (block.data.layout === 'Grid') {
        @for (item of block.content; track item.id) {
            <ng-container *ngTemplateOutlet="cardEvent; context: { item: item }"></ng-container>
        }
    }
</div>

<ng-template #cardEvent let-item="item">
    <div class="card-event">
        <div class="card-event__content">
            @if (item.data.eventTitle) {
                <h2 class="card-event__heading" [innerText]="item.data.eventTitle"></h2>
            }

            <div class="card-event__info-wrapper">
                @if (item.data.timeAndDate) {
                    <div class="d-flex gap-2 mb-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z"
                                stroke="var(--color-primary)"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M16 2V6"
                                stroke="var(--color-primary)"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M8 2V6"
                                stroke="var(--color-primary)"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M3 10H21"
                                stroke="var(--color-primary)"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <div [innerHTML]="item.data.timeAndDate"></div>
                    </div>
                }

                @if (item.data.location) {
                    <div class="d-flex gap-2 mb-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
                                stroke="var(--color-primary)"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z"
                                stroke="var(--color-primary)"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <div [innerHTML]="item.data.location"></div>
                    </div>
                }

                @if (item.data.online) {
                    <div class="d-flex gap-2 mb-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                stroke="var(--color-primary)"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M2 12H22"
                                stroke="var(--color-primary)"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z"
                                stroke="var(--color-primary)"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <div [innerHTML]="item.data.online"></div>
                    </div>
                }
            </div>

            @if (item.data.description) {
                <div
                    class="card-event__description"
                    [class.is-expanded]="expandedItems.has(item.id)"
                    [innerHTML]="item.data.description"></div>
            }

            <div class="card-event__links">
                @if (item.data.linkText && item.data.link) {
                    @if (item.data.target === '_blank') {
                        <a class="btn btn-primary btn--small mb-0" [href]="item.data.link" target="_blank">
                            <span [innerText]="item.data.linkText | translate"></span>
                        </a>
                    } @else {
                        <a class="btn btn-primary btn--small mb-0" [routerLink]="item.data.link">
                            <span [innerText]="item.data.linkText | translate"></span>
                        </a>
                    }
                }

                @if (item.data.description) {
                    <span class="d-flex align-items-center gap-2">
                        <a
                            class="card-event__show-more"
                            href="javascript:void(0)"
                            (click)="toggleDescription(item.id, $event)"
                            [innerText]="
                                (expandedItems.has(item.id) ? 'Show less details' : 'Show more details') | translate
                            "></a>
                        <svg
                            [class.is-expanded]="expandedItems.has(item.id)"
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="12"
                            viewBox="0 0 15 12"
                            fill="none">
                            <path
                                d="M0.833252 5.83334H14.1666M9.16659 10.8333L14.1666 5.83334L9.16659 0.833344"
                                stroke="var(--color-primary)"
                                stroke-width="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </span>
                }
            </div>
        </div>
    </div>
</ng-template>
